import React, { useEffect, useState } from 'react'
import Axios from 'axios'
import Chart from '../chart'
import Table from '../table'
import DataLayout from '../data-layout'

const SpendingByDepartment = ({
  match: {
    params: { year }
  }
}) => {
  const [data, setData] = useState([])

  useEffect(() => {
    const loadData = async () => {
      const result = await Axios.get(`/GetDepartmentSpending/${year}`)
      const _data = result.data.map(d => ({
        name: d.DeptName.trim(),
        nameClick: `/department/${year}/${d.OrgCode.trim()}?deptName=${d.DeptName.trim()}`,
        data: d.CurrentYearActual
      }))
      setData(_data.sort((a, b) => b.data - a.data))
    }

    loadData()
  }, [year])

  return (
    <DataLayout year={year}>
      <Chart data={data} />
      <Table
        data={{
          headers: [
            {
              title: 'Department',
              dataKey: 'name',
              clickThrough: 'nameClick'
            },
            {
              title: 'Amount',
              dataKey: 'data'
            }
          ],
          data
        }}
      />
    </DataLayout>
  )
}
export default SpendingByDepartment
